module.exports = __webpack_public_path__ + "fonts/Antenna-Black.510632fc.ttf";